import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId } from '../../../sites';

import CommonKlevuInit from './common';

function KlevuInit(props) {
  if (isEqual(siteId, siteIds.Viinimaa) || isEqual(siteId, siteIds.Folkofolk) || isEqual(siteId, siteIds.AnoraPro)) {
    return <CommonKlevuInit {...props} />;
  }

  return null;
}

export default KlevuInit;
